import { apiClient } from "./authService";

// ── Members ───────────────────────────────────────────────────

export interface MemberItem {
  _id: string;
  name: string;
  avatar?: string;
  bio?: string;
  email: string;
  isFollowing: boolean;
  isFollowedBy: boolean;
  isMutual: boolean;
}

export interface MembersPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export const membersApi = {
  list(
    page = 1,
    search = ""
  ): Promise<{ data: MemberItem[]; pagination: MembersPagination }> {
    return apiClient
      .get("/users/members", { params: { page, limit: 20, search } })
      .then((r) => ({ data: r.data.data, pagination: r.data.pagination }));
  },
};

// ── Follow ────────────────────────────────────────────────────

export const followApi = {
  follow(
    userId: string
  ): Promise<{ followed: boolean; isMutual: boolean }> {
    return apiClient.post(`/follows/${userId}`).then((r) => r.data.data);
  },

  unfollow(userId: string): Promise<{ unfollowed: boolean }> {
    return apiClient.delete(`/follows/${userId}`).then((r) => r.data.data);
  },

  getStatus(userId: string): Promise<{ isFollowing: boolean; isFollowedBy: boolean; isMutual: boolean }> {
    return apiClient.get(`/follows/${userId}/status`).then((r) => r.data.data);
  },
};
